export function isCAIP19AddressToken(address: string): boolean {
  return address.includes("erc20") || address.includes("token");
}
